var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _circle2, _rect9, _rect10, _circle3, _circle4, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _circle5, _rect23, _rect24, _rect25, _rect26, _rect27, _circle6, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _circle7, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _circle8, _rect41, _rect42, _rect43, _rect44, _circle9, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreen04Calendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 780",
    width: 360,
    height: 780,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 780,
    fill: "#0c1218"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 19,
    width: 18,
    height: 8,
    rx: 2,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 19,
    width: 14,
    height: 8,
    rx: 2,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 18,
    width: 20,
    height: 10,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 12,
    width: 100,
    height: 24,
    rx: 12,
    fill: "#000",
    opacity: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 56,
    width: 70,
    height: 7,
    rx: 3.5,
    fill: "#4b5a68",
    opacity: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 72,
    width: 140,
    height: 16,
    rx: 8,
    fill: "#dfe6e8",
    opacity: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 70,
    r: 18,
    fill: "#2c7f86",
    opacity: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 66,
    r: 7,
    fill: "#5ce1e6",
    opacity: 0.9
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 112,
    width: 320,
    height: 300,
    rx: 18,
    fill: "#141d27",
    opacity: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 132,
    width: 110,
    height: 10,
    rx: 5,
    fill: "#dfe6e8",
    opacity: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 284,
    cy: 137,
    r: 12,
    fill: "#1a2531",
    opacity: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 137,
    r: 12,
    fill: "#1a2531",
    opacity: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 168,
    width: 14,
    height: 5,
    rx: 2.5,
    fill: "#4b5a68",
    opacity: 1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 168,
    width: 14,
    height: 5,
    rx: 2.5,
    fill: "#4b5a68",
    opacity: 1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 168,
    width: 14,
    height: 5,
    rx: 2.5,
    fill: "#4b5a68",
    opacity: 1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 168,
    width: 14,
    height: 5,
    rx: 2.5,
    fill: "#4b5a68",
    opacity: 1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 168,
    width: 14,
    height: 5,
    rx: 2.5,
    fill: "#4b5a68",
    opacity: 1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 168,
    width: 14,
    height: 5,
    rx: 2.5,
    fill: "#4b5a68",
    opacity: 1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 168,
    width: 14,
    height: 5,
    rx: 2.5,
    fill: "#4b5a68",
    opacity: 1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 201,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 201,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 201,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 201,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 201,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 216,
    r: 2.5,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 201,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 201,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 243,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 243,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 243,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 258,
    r: 2.5,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 243,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 243,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 243,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 243,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 285,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 285,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 285,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 288,
    r: 17,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 285,
    width: 14,
    height: 6,
    rx: 3,
    fill: "#05070a",
    opacity: 1
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 285,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 285,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 285,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 327,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 327,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 342,
    r: 2.5,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 327,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 327,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 327,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 327,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 342,
    r: 2.5,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 327,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 369,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 369,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 369,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.75
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 369,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#34424f",
    opacity: 0.75
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 369,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#34424f",
    opacity: 0.75
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 369,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#34424f",
    opacity: 0.75
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 369,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#34424f",
    opacity: 0.75
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 430,
    width: 320,
    height: 70,
    rx: 16,
    fill: "#141d27",
    opacity: 1
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 430,
    width: 5,
    height: 70,
    rx: 2,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 446,
    width: 160,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 464,
    width: 110,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 448,
    width: 56,
    height: 8,
    rx: 4,
    fill: "#5ce1e6",
    opacity: 0.8
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 512,
    width: 320,
    height: 70,
    rx: 16,
    fill: "#141d27",
    opacity: 1
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 512,
    width: 5,
    height: 70,
    rx: 2,
    fill: "#4b5a68",
    opacity: 1
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 528,
    width: 160,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 546,
    width: 110,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 530,
    width: 56,
    height: 8,
    rx: 4,
    fill: "#5ce1e6",
    opacity: 0.8
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 594,
    width: 320,
    height: 70,
    rx: 16,
    fill: "#141d27",
    opacity: 1
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 594,
    width: 5,
    height: 70,
    rx: 2,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 610,
    width: 160,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 628,
    width: 110,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 612,
    width: 56,
    height: 8,
    rx: 4,
    fill: "#5ce1e6",
    opacity: 0.8
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 696,
    width: 360,
    height: 84,
    rx: 0,
    fill: "#141d27",
    opacity: 1
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#4b5a68",
    opacity: 1
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#34424f",
    opacity: 1
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#4b5a68",
    opacity: 1
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#34424f",
    opacity: 1
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#4b5a68",
    opacity: 1
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#34424f",
    opacity: 1
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 716,
    width: 22,
    height: 22,
    rx: 6,
    fill: "#4b5a68",
    opacity: 1
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 744,
    width: 28,
    height: 5,
    rx: 2.5,
    fill: "#34424f",
    opacity: 1
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 766,
    width: 120,
    height: 5,
    rx: 2.5,
    fill: "#dfe6e8",
    opacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen04Calendar);
export default __webpack_public_path__ + "static/media/screen-04-calendar.09efab524877570573fcb2d92b5acedb.svg";
export { ForwardRef as ReactComponent };